import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentListaDeCardsComIconeTituloDescricaoSidebarComTituloDescricaoCta {
    constructor() {

        this.sections = document.querySelectorAll('.component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta')

        this.sliders = document.querySelectorAll(".swiper--component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta")
        // this.navigationPrev = document.querySelector(".slider-button-prev--component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta")
        // this.navigationNext = document.querySelector(".slider-button-next--component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta")
        // this.pagination = document.querySelector(".slider-pagination--component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta")

        this.ready();
    }

    ready() {

        if(this.sections) {
            this.sections.forEach((current, index) => {

                current.classList.add('current-'+index)
                const sliderCurrent = current.querySelector('.swiper--component-lista_de_cards_com_icone_titulo_descricao_sidebar_com_titulo_descricao_cta')
                const swiper = new Swiper(sliderCurrent, {
                    modules: [Navigation, Pagination],
                    grabCursor: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: document.querySelector('.current-'+index+' .slider-button-next--cp-nav'),
                        prevEl: document.querySelector('.current-'+index+' .slider-button-prev--cp-nav')
                    },
                    pagination: {
                        el: document.querySelector('.current-'+index+' .slider-pagination--cp-nav'),
                        clickable: true,
                    },
                    slidesPerView: 1.3,
                    spaceBetween: 22,
                    slidesOffsetBefore: 22,
                    slidesOffsetAfter: 22
                })
            })
        }

        
    }
}